import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const useStyles = makeStyles((theme) => ({
  footerWrapper: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(5)
  },
  descopeWidgets: {
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    margin: '0 auto',
    marginBottom: theme.spacing(4),
    '& > * + *': {
      marginTop: theme.spacing(4)
    }
  }
}));

export default useStyles;
